import {
  SET_USER,
  SET_USER_LOGGED,
  SET_REPRESENTED_ID,
  SET_REPRESENTED,
  SET_USER_ACCESS,
  SET_USER_LOGGED_IN_TOKEN,
  SET_REPRESENTS,
  SET_USER_VALID
} from './actionTypes';

export const setUser = (value) => ({
  type: SET_USER,
  newValue: value
});

export const setUserLogged = (value) => ({
  type: SET_USER_LOGGED,
  newValue: value
});

export const setRepresentedId = (value) => ({
  type: SET_REPRESENTED_ID,
  newValue: value
});

export const setRepresented = (value) => ({
  type: SET_REPRESENTED,
  newValue: value
});

export const setRepresents = (value) => ({
  type: SET_REPRESENTS,
  newValue: value
});

export const setAcesso = (value) => ({
  type: SET_USER_ACCESS,
  newValue: value
});

export const userLoggedInActionToken = (value) => ({
  type: SET_USER_LOGGED_IN_TOKEN,
  newValue: value
});

export const setUserValid = (value) => ({
  type: SET_USER_VALID,
  newValue: value
});
